import moment from 'moment';

export enum ScheduledStatus {
  BOOKED = 'booked',
  CANCELLED = 'cancelled',
  COMPLETE = 'complete',
  'NOT_COMPLETE' = 'not complete',
  PENDING = '',
}

export const checkIfCancelledStatus = (status: string) => status.includes('cancel');

export const shouldUpdateConsultingScheduledStatus = (
  scheduledStatus: string | ScheduledStatus,
  calendlyStartTime: any,
  previousScheduledStatus: string | ScheduledStatus | undefined
): string | undefined => {
  if (
    checkIfCancelledStatus(scheduledStatus) &&
    previousScheduledStatus === ScheduledStatus.BOOKED
  ) {
    return ScheduledStatus.CANCELLED.toString();
  }
};

export const getConsultType = (
  scheduledStatus: string | ScheduledStatus,
  calendlyStartTime: any
): string => {
  if (scheduledStatus === ScheduledStatus.COMPLETE) {
    return ScheduledStatus.COMPLETE.toString();
  }
  if (
    [ScheduledStatus.NOT_COMPLETE.toString(), ScheduledStatus.CANCELLED.toString()].includes(
      scheduledStatus
    )
  ) {
    return ScheduledStatus.CANCELLED.toString();
  }

  if (scheduledStatus === ScheduledStatus.BOOKED) {
    if (moment(calendlyStartTime * 1000).isBefore(moment())) {
      return ScheduledStatus.CANCELLED.toString();
    }
    return 'reschedule';
  }
  return 'schedule';
};
